import orderBy from 'lodash/orderBy';
import React from 'react';
import { View } from 'react-native';

import UncapturedPayment from './UncapturedPayment';

import { useConsumerUsageSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import { paymentDataFragment } from 'apollo/queries/autogenerate/operations';
import Separator from 'shared/modules/usage/components/molecules/ListItemDivider';
import ListSection from 'shared/modules/usage/components/molecules/ListSection';

type Props = {
  onPaymentItemPress: (payment: paymentDataFragment) => void;
};

const UncapturedPaymentsSection = (props: Props) => {
  const { data, error } = useConsumerUsageSummaryQuery();

  const uncapturedPayments =
    data?.consumerUsageSummary.uncapturedPayments || [];

  if (!uncapturedPayments.length) {
    return null;
  }

  return (
    <ListSection
      title="未確定"
      errorMessage={error ? 'ネットワークエラー' : ''}
      emptyMessage={!uncapturedPayments.length ? 'ご利用はありません。' : ''}
    >
      {orderBy(uncapturedPayments, 'createAt', 'desc').map((payment, index) => (
        <View key={payment.id}>
          <UncapturedPayment
            payment={payment}
            onPress={props.onPaymentItemPress}
            id={`uncaptured-payments-item-${index}`}
          />
          {index !== uncapturedPayments.length - 1 && <Separator />}
        </View>
      ))}
    </ListSection>
  );
};

export default UncapturedPaymentsSection;
